// extracted by mini-css-extract-plugin
export default {"tableRow":"areaList_tableRow__EVFW+","tableCell":"areaList_tableCell__W-NOA"};